export default {
  GET_WEBINAR_LIST: '/manage/webinar/findList',
  GET_SUBSCRIBER_LIST: '/manage/webinarSubscriber/findList',
  GET_WEBINAR_DETAIL: '/manage/webinar/find',
  UPDATE_WEBINAR: '/manage/webinar/update',
  SAVE_WEBINAR: '/manage/webinar/save',
  concept: '/auth/concept/findFilterByKeyword',
  EXPORT_LIST: '/manage/webinar/exportList',
  CHANGE_STATEUS: '/manage/webinar/updateStatus',
  SAVE_SAMPLE: '/auth/webinar/sample/save',
  getSampleRequestTotal: '/manage/webinar/sample/exportTotal',
  del: '/manage/webinar/delete'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/webinar.js